import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { MiscService } from "app/shared/misc.service";

const DISMISS_KEY = "twofa-banner-dismissed-session";

@Component({
  selector: "app-twofa-security-banner",
  templateUrl: "./twofa-security-banner.component.html",
  styleUrls: ["./twofa-security-banner.component.scss"],
})
export class TwofaSecurityBannerComponent implements OnInit, OnDestroy {
  twoFaEnabled: boolean = true;
  dismissed: boolean = false;
  isGB: boolean = false;
  private unsubscribe$ = new Subject<void>();
  merchantDetails: any;

  constructor(private miscService: MiscService) {}

  ngOnInit(): void {
    this.dismissed =
      sessionStorage.getItem(DISMISS_KEY) === this.currentSessionId();
    this.merchantDetails = this.miscService.getMerchantDetails();
    this.updateStatus(this.merchantDetails);
    this.miscService.userSubject
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((user) =>
        this.updateStatus(user ?? this.miscService.getMerchantDetails()),
      );
  }

  private currentSessionId(): string {
    return localStorage.getItem("session_id") || "";
  }

  private updateStatus(user: any): void {
    this.twoFaEnabled = !!user?.security?.["2fa"]?.enabled;
    this.dismissed =
      sessionStorage.getItem(DISMISS_KEY) === this.currentSessionId();
    this.isGB = user?.currency?.iso_code_2 === "GB";
  }

  dismiss(): void {
    this.dismissed = true;
    sessionStorage.setItem(DISMISS_KEY, this.currentSessionId());
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
